import axios from '@/integrations/axios'
import { toQueryParams } from '@/lib/utils'
import type { InvoiceListQuery, InvoiceListResponse, InvoiceResponse } from '@backend/schemas'

export const fetchInvoices = async (params: Partial<InvoiceListQuery>) => {
  const response = await axios.get<InvoiceListResponse>(`/v1/invoices`, { params: toQueryParams(params) })
  const data = response.data
  return data
}

export const fetchInvoiceById = async (id: string) => {
  const response = await axios.get<InvoiceResponse>(`/v1/invoices/${id}`)
  const data = response.data
  return data
}
